import {floor} from "lodash";
import React from "react";
import {Link} from "react-router-dom";

import {EModules} from "@/models";
import {IModuleGroup} from "@shared/analysis/analyze-button/models";
import {IModuleInfo} from "@toolbox/display-blocks/models";
import {EServerId} from "../../models";

import ModuleIcon, {getModuleInfo} from "@toolbox/display-blocks/ModuleIcon";

export interface IAnalyzeStandardProps {
    project: number;
    serverId: EServerId;
    modules: IModuleGroup[];
    columns: number;

    hrefTarget?: string;

    getTargets(engine?: EModules): string;
    onClick(): void;
}

class AnalyzeStandard extends React.PureComponent<IAnalyzeStandardProps> {
    public render() {
        const {modules, columns} = this.props;
        const last = modules.length - 1;

        return modules.map((group, i) => (
            <div key={group.id} className={last !== i ? "mb-2" : undefined}>
                <h5 className="header border-bottom">{group.header}</h5>
                <ul className="list-unstyled" style={{columns}}>
                    {this.renderButtons(group)}
                </ul>
            </div>
        ));
    }

    private renderButtons(group: IModuleGroup) {
        const {columns} = this.props;
        const last = floor(group.modules.length - 1 / columns);

        return group.modules.map((engine, i) =>
            this.renderButton(
                engine,
                getModuleInfo(engine),
                last === floor(i / columns),
            ),
        );
    }

    private renderButton(
        engine: EModules,
        info: IModuleInfo,
        lastRow: boolean,
    ) {
        const {onClick, hrefTarget} = this.props;

        return (
            <li key={engine} className={!lastRow ? "mb-1" : undefined}>
                <Link
                    id={`link-to-${engine}`}
                    target={hrefTarget}
                    to={this.getUrl(engine)}
                    onClick={onClick}
                >
                    <ModuleIcon icon={info.icon} name={info.type} />
                </Link>
            </li>
        );
    }

    private getUrl(engine: EModules) {
        const {project, getTargets, serverId} = this.props;
        const targets = getTargets(engine);
        return `/project/${project}/${serverId}/analyze?engine=${engine}&${targets}`;
    }
}

export default AnalyzeStandard;
